export function perceptionCheckboxShow(context) {
	let { areaType, cardInfo, showCardCheckboxController } = context;
	let { areaid } = cardInfo;

	return !!showCardCheckboxController[areaid]
}
